// extracted by mini-css-extract-plugin
export default {"sidebar":"nPnN3","search-sidebar":"HwLwI"};